/**
 * The YouTube video id in a link a user pastes: watch pages, short links, shorts, live and
 * embed links; null for anything else (including other sites).
 */
export function youtubeId(raw) {
    let url;
    try {
        url = new URL(raw.trim());
    }
    catch {
        return null;
    }
    if (url.protocol !== 'https:' && url.protocol !== 'http:')
        return null;
    const host = url.hostname.replace(/^www\.|^m\.|^music\./, '');
    const id = (v) => (v && /^[\w-]{11}$/.test(v) ? v : null);
    if (host === 'youtu.be')
        return id(url.pathname.split('/')[1]);
    if (host !== 'youtube.com' && host !== 'youtube-nocookie.com')
        return null;
    const [, kind, rest] = url.pathname.split('/');
    if (kind === 'watch')
        return id(url.searchParams.get('v'));
    if (kind === 'shorts' || kind === 'embed' || kind === 'live' || kind === 'v')
        return id(rest);
    return null;
}
/** The canonical watch URL of a YouTube link (what a model is given), or null. */
export function youtubeWatchUrl(raw) {
    const id = youtubeId(raw);
    return id ? `https://www.youtube.com/watch?v=${id}` : null;
}
/**
 * The still YouTube keeps for a video (user 2026-09-30: offered as the recipe's picture).
 * `max` is the large one, which not every video has; `hq` (480×360) always exists.
 */
export function youtubeThumbnailUrl(raw, quality = 'hq') {
    const id = youtubeId(raw);
    if (!id)
        return null;
    return `https://i.ytimg.com/vi/${id}/${quality === 'max' ? 'maxresdefault' : 'hqdefault'}.jpg`;
}
//# sourceMappingURL=youtube.js.map